(function () {
  function slugify(text, index) {
    const base = text
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\u3040-\u30ff\u3400-\u9fff-]/g, '')
      .slice(0, 48);

    return 'section-' + index + (base ? '-' + base : '');
  }

  function initTableOfContents() {
    const content = document.querySelector('.cbd-blog-article .article-template__content');
    const toc = document.querySelector('.cbd-article-toc');
    const list = toc ? toc.querySelector('.cbd-article-toc__list') : null;

    if (!content || !toc || !list) return;

    const headings = Array.from(content.querySelectorAll('h2'));
    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = slugify(heading.textContent || '', index + 1);
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
  }

  function isA8TrackingPixel(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'IMG') {
      return false;
    }

    const src = node.getAttribute('src') || '';
    return (
      node.getAttribute('width') === '1' &&
      node.getAttribute('height') === '1' &&
      src.indexOf('a8.net') !== -1
    );
  }

  function absorbFollowingTrackingPixel(wrap) {
    let sibling = wrap.nextSibling;

    while (sibling) {
      if (sibling.nodeType === Node.TEXT_NODE && !sibling.textContent.trim()) {
        sibling = sibling.nextSibling;
        continue;
      }

      if (isA8TrackingPixel(sibling)) {
        wrap.appendChild(sibling);
        sibling = wrap.nextSibling;
        continue;
      }

      break;
    }
  }

  function isA8ProductTable(table) {
    if (!table || table.closest('.a8-ad-wrap')) {
      return false;
    }

    const tableStyle = table.getAttribute('style') || '';
    const hasAffiliateLink = !!table.querySelector(
      'a[href*="a8.net"], a[href*="px.a8.net"], a[href*="a8fly.com"]'
    );

    return (
      hasAffiliateLink &&
      (tableStyle.indexOf('300px') !== -1 ||
        !!table.querySelector('img[src*="_ex=128x128"]'))
    );
  }

  function initA8AdWraps() {
    const content = document.querySelector('.cbd-blog-article .article-template__content');
    if (!content) return;

    Array.from(content.querySelectorAll('table')).forEach((table) => {
      if (!isA8ProductTable(table)) return;

      const wrap = document.createElement('div');
      wrap.className = 'a8-ad-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
      absorbFollowingTrackingPixel(wrap);
    });

    content.querySelectorAll('.a8-ad-wrap').forEach(absorbFollowingTrackingPixel);
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-cbd-copy-url]').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = button.getAttribute('data-cbd-copy-url');
        const label = button.querySelector('.cbd-article-share__copy-text');
        if (!url) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            const input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
          }

          if (label) {
            const original = label.textContent;
            label.textContent = 'コピーしました';
            button.classList.add('is-copied');
            window.setTimeout(() => {
              label.textContent = original;
              button.classList.remove('is-copied');
            }, 1800);
          }
        } catch (error) {
          if (label) {
            label.textContent = 'コピーできませんでした';
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initA8AdWraps();
      initTableOfContents();
      initCopyButtons();
    });
  } else {
    initA8AdWraps();
    initTableOfContents();
    initCopyButtons();
  }
})();
